var ButtonDropdownOption = require("components/utility/ButtonDropdownOption");
var ButtonDropdown = require("components/utility/ButtonDropdown");

class StudentListDropdownDisplay extends React.Component {
	constructor(props) {
		super();
		autobind(this);

		var mixedDisplay = false;
		if (props.studentLists.length && !props.allClassesOption) {
			var id = props.studentLists[0].id

			if (props.displayType == "mixed"){
				for( var i = 0; i < props.studentLists.length; i ++){
					if (props.studentLists[i].label != null) {
						mixedDisplay = true
						break
					}
				}
			}
		}

		if (props.currentStudentList) {
			id = props.currentStudentList.id;
		}

		this.state = {
			currentID: id, mixedDisplay: mixedDisplay
		};
	}

	buildStudentListSelect(studentList) {
		return function(e) {
			$wr.nope(e)
			this.setState({ currentID: studentList.id }, function(){
				if (this.props.onChange) {
					this.props.onChange(studentList);
				}
			});
		}.bind(this);
	}

	selectAllClasses() {
		this.setState({ currentID: null }, function(){
			if (this.props.onChange) {
				this.props.onChange(null);
			}
		});

	}

	getStudentListOptions(studentList) {
		var options = studentList.map(function(sl) {
			var bold = this.state.mixedDisplay && !sl.label;
			return (
				<ButtonDropdownOption onClick={ this.buildStudentListSelect(sl) }
					text={ sl.name } icon={ sl.label } key={ sl.id } bold={ bold }/>
			);
		}.bind(this));

		if (this.props.allClassesOption) {
			options.unshift(
				<ButtonDropdownOption onClick={ this.selectAllClasses }
					text={ "All Classes" } key="all-classes" />
			)
		}

		return options;
	}

	getSelected(studentLists) {
		var ids = studentLists.map(function(l) {
			return l.id;
		});
		var index = ids.indexOf(this.state.currentID);
		if (index < 0) {
			if (this.props.allClassesOption) {
				return null;
			}
			index = 0;
		}
		return studentLists[index]
	}

	getMixedStudentList() {
		var mixedStudentList = []
		for (var i = 0; i < this.props.studentLists.length; i++) {
			mixedStudentList.push(this.props.studentLists[i])
			for (var j = 0; j < this.props.studentLists[i].sub_groups.length; j++) {
				mixedStudentList.push(this.props.studentLists[i].sub_groups[j])
			}
		}
		return mixedStudentList
	}

	render() {
		switch (this.props.displayType) {
			case "group":
				var studentList = this.props.studentLists.sub_groups
			break
			case "mixed":
				var studentList = this.props.studentLists
			break
			default:
				var studentList = this.props.studentLists.filter(function(sl){
					return sl.label == null
				})
			break
		}
		var dropdownBody = this.getStudentListOptions(studentList)
		var currentStudentList = this.getSelected(studentList)

		if (currentStudentList) {
			var text = currentStudentList.name
			var label = currentStudentList.label
		} else if (this.props.allClassesOption) {
			var text = "All Classes";
		}

		return (
			<ButtonDropdown text={ text } icon={ label }
				dropdownDisplay={ this.props.dropdownDisplay }
				className="studentListSelector subGroupLabel" >
				{ dropdownBody }
			</ButtonDropdown>
		)
	}
};

StudentListDropdownDisplay.propTypes = StrictPropTypes({

	allClassesOption: PropTypes.bool,

	// List of student_list objects to form the options
	studentLists: PropTypes.array.isRequired,

	// Changes the way the menu is structured
	displayType: PropTypes.string,

	// Toggles formatting changes
	dropdownDisplay: PropTypes.string,

	// Function to call after selected option changes
	onChange: PropTypes.func,

	currentStudentList: PropTypes.object
});

module.exports = StudentListDropdownDisplay;



// WEBPACK FOOTER //
// ./modules/components/org/StudentListDropdownDisplay.js